<template>
  <span>
    <div
      id="message-register"
      :class="{'boss-layout-block-large':isEnabledForCreateMessageAccordion}"
    >
      <template v-if="isWithdraw">
        <span
          class="boss-annotation-text font-size-1-1em text-center"
          data-test="withdraw"
        >
          <div>
            応募後に退会したため、メッセージ送信ができません。
          </div>
          <div>
            レジュメ内のご連絡先に、直接ご連絡ください。
          </div>
        </span>
      </template>
      <template v-else>
        <accordion
          v-if="canSendMessage"
          ref="register"
          :is-open="false"
          :disabled="!isEnabledForCreateMessageAccordion"
        >
          <template #head>メッセージ作成</template>
          <template #body>
            <entry-message-register
              :entry-ids="entryIds"
              :message-to-applicant.sync="messageToApplicant"
              @registered="registered"
            />
          </template>
        </accordion>
        <div
          v-if="!isEnabledForCreateMessageAccordion"
          class="boss-annotation-text pega-entry-message-reservation-reserved-label"
          data-test="reserved"
        >
          ※メッセージ予約中
        </div>
      </template>
    </div>
    <div class="boss-layout-block-large">
      <entry-message-history
        ref="entryMessageHistory"
        :entry-id="entryId"
        :is-withdraw="isWithdraw"
        @setMessage="setMessage"
        @setIsMessageReserved="setIsMessageReserved"
      />
    </div>
  </span>
</template>

<script>
import EntryMessageRegister from '@/components/organisms/EntryMessageRegister'
import Accordion from '@/components/atoms/Accordion'
import EntryMessageHistory from '@/components/organisms/EntryMessageHistory'
import { mapGetters } from 'vuex'
import SelectionEventBus from '@/lib/selectionEventBus'

export default {
  components: {
    Accordion,
    EntryMessageRegister,
    EntryMessageHistory
  },
  props: {
    entryId: {
      type: Number,
      required: true
    },
    isWithdraw: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      messageToApplicant: null,
      isMessageReserved: false,
      isTriggeredEnableCreateMessage: false
    }
  },
  computed: {
    ...mapGetters([
      'canSendMessage'
    ]),
    isEnabledForCreateMessageAccordion () {
      return !this.isMessageReserved || this.isTriggeredEnableCreateMessage
    },
    entryIds () {
      return [this.entryId]
    }
  },
  methods: {
    setMessage (data) {
      this.$set(this, 'messageToApplicant', null)
      this.$set(this, 'isTriggeredEnableCreateMessage', true)

      this.$nextTick(() => {
        this.$set(this, 'messageToApplicant', data)
        this.$refs.register.status.isOpen = true
        this.$scrollTo('#message-register', 0, { offset: -35 })
      })
    },
    setIsMessageReserved (isMessageReserved) {
      this.$set(this, 'isMessageReserved', isMessageReserved)
    },
    registered () {
      this.$refs.register.status.isOpen = false
      this.$set(this, 'isTriggeredEnableCreateMessage', false)
      this.$refs.entryMessageHistory.fetchAllMessage()
      SelectionEventBus.emitSelectionUpdate()
    }
  }
}
</script>
